import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "24",
  fill: "none",
  viewBox: "0 0 23 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.263 23.52a.45.45 0 0 1-.447-.448c0-.83 1.47-3.928 1.763-6.354.032-.26-.346-.357-.484-.134-.757 1.217-1.79 2.921-4.304 2.862l-.049.001q-.048.002-.098.003C2.914 19.45.7 17.016.7 14.014s2.214-5.435 4.944-5.435c.534 0 1.047.093 1.528.264.112.04.226-.09.17-.196a5.8 5.8 0 0 1-.67-2.733C6.672 2.954 8.8.48 11.5.48s4.828 2.475 4.828 5.434c0 .997-.244 1.93-.67 2.733-.056.106.058.237.17.196a4.5 4.5 0 0 1 1.528-.264c2.73 0 4.944 2.433 4.944 5.435s-2.214 5.436-4.944 5.436l-.098-.003-.05-.001c-2.514.06-3.546-1.645-4.303-2.862-.138-.223-.516-.126-.484.134.294 2.426 1.763 5.525 1.763 6.354 0 .248-.2.448-.447.448z"
    }, null, -1)
  ])))
}
export default { render: render }